import React from 'react';
import { TopicWithSentiment } from '../../types/analytics';

interface TopicWordCloudProps {
  topics: TopicWithSentiment[];
  onTopicClick?: (topic: string) => void;
}

// Simple word cloud alternative without external library
const TopicWordCloud: React.FC<TopicWordCloudProps> = ({ topics, onTopicClick }) => {
  const getSize = (count: number, maxCount: number): string => {
    const ratio = count / maxCount;
    if (ratio > 0.8) return 'text-4xl';
    if (ratio > 0.6) return 'text-3xl';
    if (ratio > 0.4) return 'text-2xl';
    if (ratio > 0.2) return 'text-xl';
    return 'text-lg';
  };

  const getColor = (sentiment: number): string => {
    if (sentiment > 0.3) return 'text-green-600';
    if (sentiment < -0.3) return 'text-red-600';
    return 'text-yellow-600';
  };

  const maxCount = Math.max(...topics.map((t) => t.count));

  return (
    <div className="flex flex-wrap gap-4 p-6 bg-white rounded-lg justify-center items-center min-h-[300px]">
      {topics.map((topic, index) => (
        <button
          key={index}
          onClick={() => onTopicClick && onTopicClick(topic.topic)}
          className={`font-['Open_Sans'] font-semibold ${getSize(topic.count, maxCount)} ${getColor(topic.avg_sentiment)} hover:opacity-75 transition-opacity ${
            onTopicClick ? 'cursor-pointer' : 'cursor-default'
          }`}
          style={{
            margin: `${Math.random() * 10}px ${Math.random() * 10}px`,
          }}
        >
          {topic.topic}
        </button>
      ))}
    </div>
  );
};

export default TopicWordCloud;
